import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DmsUser } from "../../../domain/entities/user";
import { type UsersDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listUsers = createAsyncThunk<
  DmsUser[],
  void,
  { dispatch: UsersDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_USERS, async (_, { extra }) => {
  return await extra.usersRepo.listUsers();
});
